"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function NotFound() {
    return (react_1.default.createElement("svg", { width: "56", height: "56", viewBox: "0 0 56 56" },
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("rect", { width: "56", height: "56" }),
            react_1.default.createElement("g", { transform: "translate(4 9)" },
                react_1.default.createElement("rect", { width: "50", height: "36", x: "-1", y: "-1", fill: "#F5F5F5", stroke: "#BFBFBF", strokeWidth: "2" }),
                react_1.default.createElement("text", { fill: "#BFBFBF", fontSize: "16", fontWeight: "400" },
                    react_1.default.createElement("tspan", { x: "10.1", y: "23" }, "404")),
                react_1.default.createElement("rect", { width: "2", height: "4", x: "23", y: "36", fill: "#BFBFBF" }),
                react_1.default.createElement("rect", { width: "26", height: "2", x: "11", y: "40", fill: "#BFBFBF" })))));
}
exports.default = NotFound;
//# sourceMappingURL=NotFound.js.map